import { render, staticRenderFns } from "./AstmDeviceIndexComponent.vue?vue&type=template&id=464835ae"
import script from "./AstmDeviceIndexComponent.vue?vue&type=script&lang=js"
export * from "./AstmDeviceIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports